export default {"src":"/_next/static/media/arrow-up.d110b232.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};